import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import SoldWordIcon from 'dibs-vg/dist/react/sold';
import { itemStatus } from '../pdpMessages';
import styles from './PdpSharedSoldHeader.scss';

const PdpSharedSoldHeaderComponent = ({ item }) => {
    const { title } = item;

    return (
        <Fragment>
            <div className={styles.title}>{title}</div>
            <div className={styles.statusContainer}>
                <span className={styles.itemStatus}>{itemStatus}</span>
                <span className={styles.iconContainer}>
                    <SoldWordIcon className={styles.icon} />
                </span>
            </div>
        </Fragment>
    );
};

PdpSharedSoldHeaderComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpSharedSoldHeader = createFragmentContainer(PdpSharedSoldHeaderComponent, {
    item: graphql`
        fragment PdpSharedSoldHeader_item on Item {
            title
        }
    `,
});
